import React from "react";
import ServiceLabel from "../../Components/ServiceLabel/ServiceLabel";
import { servicesLabels } from "../../Utils/data";
import serviceBottom from "../../assets/servicesbottom.png";

const Services = () => {
  return (
    <section id="services">
      <div className="max-w-full md:container mx-0 md:mx-auto py-10 sm:py-20 px-0 sm:px-4">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div className="col-span-2">
            <div class="grid grid-cols-2 sm:grid-cols-3 gap-4 mx-1 sm:mx-4 justify-center">
              {servicesLabels?.map((service) => (
                <ServiceLabel
                  key={service?.id}
                  label={service?.serviceName}
                  imgPath={service?.image}
                  toPath={service?.url + service?.id}
                  serviceIcon={service?.serviceIcon}
                />
              ))}
            </div>
          </div>
          <div className="flex flex-col items-center md:items-end col-span-2 md:col-span-1">
            <p className="font-font-Montserrat text-5xl lg:text-6xl text-center md:text-right leading-[60px] sm:leading-[100px] font-semibold tracking-wide uppercase pt-4 sm:pt-8">
              Our Services
            </p>
            <p className="font-font-Titillium text-sm md:text-lg text-[#262626] text-center md:text-right font-normal tracking-wide uppercase pt-4 sm:pt-8 w-[193px]">
              {`<< Click on each service to learn more`}
            </p>
          </div>
        </div>
      </div>
      <div
        className={`bg-[#f5f5f5]`}
        style={{
          backgroundImage: `url(${serviceBottom})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "right",
        }}
      >
        <div className="container mx-0 md:mx-auto sm:py-8 md:py-20 px-4 ">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            <div className="col-span-2">
              <div className="flex flex-col items-start col-span-2 sm:col-span-1">
                <p className="font-font-Montserrat text-[#FAAD14] text-2xl lg:text-4xl leading-[32px] sm:leading-[62px] font-semibold tracking-wide uppercase pt-4 sm:pt-8">
                  Who are these services for?
                </p>
                <p className="font-font-Titillium text-base md:text-xl text-[#262626] font-normal tracking-wide uppercase pt-4 sm:pt-8">
                  For entrepreneurs, corporate executives and high-performance
                  individuals who require clinical services delivered in the
                  privacy and convenience of their homes. To keep the service
                  efficient and retain the quality, we keep member numbers small
                  to ensure the standard is maintained. Our bespoke service
                  offers something for an individual as well as the family.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
